import React, { useEffect, useState } from 'react'
import {
    Card,
    CardBody,
    Form,
    Alert,
    Button
} from './styles';
import { useAuth } from '../../contexts/AuthContexts';
import { useUser } from '../../contexts/UserContexts';
import { useNavigate } from 'react-router-dom';

import { db } from '../../firebase';
import { getDoc, doc, updateDoc } from "firebase/firestore";

export const UpdateProfile = () => {
    const { currentUser } = useAuth();
    const { userInfo, updateProfile } = useUser();
    const [ currentName, setCurrentName ] = useState("")
    const [ currentWeight, setCurrentWeight ] = useState()
    const [ currentHeight, setCurrentHeight ] = useState()
    const [ currentTrains, setCurrentTrains ] = useState()
    const [ currentKcal, setCurrentKcal ] = useState()
    const [ error, setError ] = useState("");
    const [ loading, setLoading ] = useState(true);
    const history = useNavigate();

    const getInfoFromContext = async () => {
        if(!currentUser || !currentUser.uid) return;
        setLoading(true);

        const userData = userInfo;

        if(!!userData){
            setCurrentName(userData.name);
            setCurrentWeight(userData.currentWeight);
            setCurrentHeight(userData.height);
            setCurrentTrains(userData.weekTrains);
            setCurrentKcal(userData.dietKcal);

            console.log("coletando do Context", userData);
        }else{
            console.log("Erro na consulta ao bd")
        }
        setLoading(false);
    };

    useEffect(() => {
        getInfoFromContext();
    }, []);

    const handleSubmit = async (e) => {
        setLoading(true);
        if(String(currentName) === String(userInfo.name) && String(currentWeight) === String(userInfo.currentWeight) && String(currentHeight) === String(userInfo.height) && String(currentTrains) === String(userInfo.weekTrains) && String(currentKcal) === String(userInfo.dietKcal)){
            setLoading(false);
            history("/profile");
            return;
        }
        e.preventDefault();

        try {
            await updateProfile(currentName, currentWeight, currentHeight, currentTrains, currentKcal);
            history("/profile");
        } catch (e) {
            setError(e);
            console.log("olha", e);
        }

        setLoading(false);
    }


    return (
        <>
            <Card>
                <CardBody>
                    <h2>Edição de perfil</h2>
                    { error && <Alert>{error}</Alert>}
                    <Form>
                        <div className="title-box"><span className="title">Nome</span></div>
                        <input 
                            placeholder="Nome"
                            value={currentName}
                            onChange = {(event) => {
                                setCurrentName(event.target.value);
                            }}
                        />
                        <div className="title-box"><span className="title">Peso - kg</span></div>
                        <input 
                            placeholder="Peso"
                            value={currentWeight || ""}
                            onChange = {(event) => {
                                setCurrentWeight(event.target.value);
                            }}
                        />
                        <div className="title-box"><span className="title">Altura - cm</span></div>
                        <input 
                            placeholder="Altura"
                            value={currentHeight || ""}
                            onChange = {(event) => {
                                setCurrentHeight(event.target.value);
                            }}
                        />
                        <div className="title-box"><span className="title">Calorias - kcal</span></div>
                        <input 
                            placeholder="Calorias"
                            value={currentKcal || ""}
                            onChange = {(event) => {
                                setCurrentKcal(event.target.value);
                            }}
                        />
                        <div className="title-box"><span className="title">Treinos</span></div>
                        <input 
                            placeholder="Treinos"
                            value={currentTrains || ""}
                            onChange = {(event) => {
                                setCurrentTrains(event.target.value);
                            }}
                        />

                        <Button disabled={ loading } onClick={ handleSubmit }> Confirmar </Button>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}